<template>
  <div class="multiple-choice-us">
    <div v-for="option in options" v-bind:key="option.value">
      <div :class="['multiple-choice-option', isOptionSelected(option.value) ? 'active' : '']">
        <label :for="id + '-option-' + option.value">
          <input
            type="checkbox"
            :name="id + '-option'"
            v-on:click="onOptionToggle(option.value)"
            :id="id + '-option-' + option.value"
            :checked="isOptionSelected(option.value)"
          />
          <span class="checkmark square"></span>
          <span class="option-label" :class="styleForOption(option.value)">{{ option.label }}</span>
        </label>
      </div>
      <div
        class="option-warning list-as-bullets pl-10 my-5 mt-6"
        role="alert"
        v-if="option.warningText && isOptionSelected(option.value)"
        v-html="option.warningText"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: ["value", "options", "id"],
  data: function () {
    return {
      answers: this.value || [],
    };
  },
  methods: {
    getOptionForValue: function (value) {
      return this.options.filter((option) => option.value === value)[0];
    },
    styleForOption: function (value) {
      if (this.getOptionForValue(value).exclusive) {
        return "font-bold";
      }
      return "";
    },
    onOptionToggle: function (value) {
      const optionElement = this.getOptionForValue(value);
      if (this.isOptionSelected(value)) {
        this.answers = this.answers.filter((answer) => answer !== value);
      } else {
        if (optionElement.exclusive) {
          this.answers = [optionElement.value];
        } else {
          this.answers = this.answers.filter((answer) => !this.getOptionForValue(answer).exclusive);
          this.answers.push(value);
        }
      }
    },
    isOptionSelected: function (value) {
      return this.answers.indexOf(value) !== -1;
    },
  },
  watch: {
    answers: function (newValue) {
      this.$emit("input", newValue);
    },
  },
});
</script>
